import type { LodgeAIAutomation } from "@/store/slices/types/lodgeAITypes";

const getModalFrameColour = (lodgeAIAutomation: LodgeAIAutomation | undefined) => {
  if (!lodgeAIAutomation) {
    return "neutral";
  }
  if (lodgeAIAutomation.isCompleted) {
    return "success";
  }
  if (lodgeAIAutomation.isManualIntervention) {
    if (lodgeAIAutomation.manualInterventionIntent === "warning") {
      return "warning";
    }
    if (lodgeAIAutomation.manualInterventionIntent === "danger") {
      return "danger";
    }
  }
  if (lodgeAIAutomation.isErrored) {
    return "danger";
  }
  return "neutral";
};

export { getModalFrameColour };
